// extracted by mini-css-extract-plugin
module.exports = {"codeInput":"SecurePhoneAuthenticationForm_codeInput__3ou0r","submitButton":"SecurePhoneAuthenticationForm_submitButton__3a4Mz"};